import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsTargetedToCompletePayload
  extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE;
    id: string;
    attributes: {
      aggregate: {
        projects_targeted_to_complete: InsightMetric;
      };
    };
  };
}

export const parseProjectsTargetedToCompletePayload = (
  payload: BaseInsightPayload
): ProjectsTargetedToCompletePayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE,
    data.attributes,
    false,
    true,
    ['projects_targeted_to_complete']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { projects_targeted_to_complete: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE,
      id: data.id,
      attributes: {
        aggregate: {
          projects_targeted_to_complete:
            typedAttributes.aggregate.projects_targeted_to_complete,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
